import React from 'react';
import { regionesComunas } from '../../constants/regionesComunas';

/**
 * Listas de región y comuna de la empresa: las comunas dependen de la región elegida.
 * Lo usan Crear empresa y Configuración para que ambos formularios se comporten igual.
 *
 * @param {Object} props
 * @param {string} props.region - Región seleccionada
 * @param {string} props.comuna - Comuna seleccionada
 * @param {Function} props.onChange - Recibe los campos que cambiaron ({ region, comuna } o { comuna })
 */
const RegionComunaSelects = ({ region, comuna, onChange }) => {
    const comunasDisponibles = regionesComunas[region] || [];

    return (
        <>
            <select
                name="region"
                value={region || ''}
                onChange={(e) => onChange({ region: e.target.value, comuna: '' })}
                required>
                <option value="" disabled>Selecciona la región</option>
                {Object.keys(regionesComunas).map(r => (
                    <option key={r} value={r}>{r}</option>
                ))}
            </select>
            <select
                name="comuna"
                value={comuna || ''}
                onChange={(e) => onChange({ comuna: e.target.value })}
                disabled={!region}
                required>
                <option value="" disabled>Selecciona la comuna</option>
                {comunasDisponibles.map(c => (
                    <option key={c} value={c}>{c}</option>
                ))}
            </select>
        </>
    );
};

export default RegionComunaSelects;
